
import React from 'react';

interface ProgramCardProps {
  title: string;
  description: string;
  color: string;
  imageUrl: string;
}

const ProgramCard: React.FC<ProgramCardProps> = ({ title, description, color, imageUrl }) => {
  const cardStyle = {
    borderColor: color,
    boxShadow: `0 10px 15px -3px ${color}40, 0 4px 6px -2px ${color}20`
  };
  const buttonStyle = { backgroundColor: color };

  return (
    <div className="bg-white rounded-2xl overflow-hidden shadow-lg border-b-8 transform hover:-translate-y-2 transition-transform duration-300 flex flex-col" style={cardStyle}>
      <img className="w-full h-48 object-cover" src={imageUrl} alt={title} />
      <div className="p-6 flex flex-col flex-grow">
        <h3 className="font-heading text-2xl font-bold text-jskool-dark mb-2">{title}</h3>
        <p className="text-jskool-dark/70 mb-4 flex-grow">{description}</p>
        <button className="mt-auto text-white font-bold font-heading py-2 px-6 rounded-lg self-start transition-opacity duration-300" style={buttonStyle}>
          Learn More
        </button>
      </div>
    </div>
  );
};

const ProgramsSection: React.FC = () => {
  return (
    <section id="programs" className="py-20 bg-jskool-cream">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-heading font-extrabold text-jskool-dark">Our Programs</h2>
          <p className="mt-4 text-lg text-jskool-dark/70 max-w-3xl mx-auto">
            Engaging and interactive Pathshala courses tailored for every age group, designed to make learning Jainism a joyful experience.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          <ProgramCard 
            title="For Kids" 
            description="Engaging, game-based lessons and animated stories that make learning fun for kids, providing parents and teachers with valuable, ready-to-use resources."
            color="#4285F4" // jskool-blue
            imageUrl="https://img.freepik.com/free-vector/children-using-laptop-learn-online_1308-46631.jpg?w=1060"
          />
          <ProgramCard 
            title="For Youth" 
            description="A dynamic curriculum with workshops and discussions that connect Jain philosophy to modern challenges, supporting teachers in guiding the next generation."
            color="#DB4437" // jskool-red
            imageUrl="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=600&auto=format&fit=crop"
          />
          <ProgramCard 
            title="For Adults" 
            description="In-depth scripture studies and practical guidance, providing a valuable resource for adult learners, parents, and teachers seeking to deepen their own understanding."
            color="#0F9D58" // jskool-green
            imageUrl="https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?q=80&w=600&auto=format&fit=crop"
          />
        </div>
      </div>
    </section>
  );
};

export default ProgramsSection;
